import productImg2 from "../../assets/portfolio/model_bgc_tee.webp";
import productImg3 from "../../assets/portfolio/model_sam_back.webp";
import productImg4 from "../../assets/portfolio/model_skeleton.webp";
import productImg6 from "../../assets/portfolio/mygoodnessclose.webp";
import productImg5 from "../../assets/portfolio/model_winch.webp";
import productImg7 from "../../assets/portfolio/model_pintoclock.webp";
import "./portfolio.css";

const Portfolio = () => {
  const imageList = [
    productImg5,
    productImg4,
    productImg7,
    productImg6,
    productImg2,
    productImg3,
  ];

  return (
    <section className="portfolio-section">
      <div className="content-padding">
        <div className="portfolio-inner">
          <div className="portfolio-header">
            <p className="portfolio-eyebrow">Out and about</p>
            <h2>In The Wild</h2>
            <p>
              Real pub-ready fits, relaxed details and Solo Pints doing what it
              does best.
            </p>
          </div>

          <div className="portfolio-grid">
            {imageList.map((item, idx) => (
              <div className="portfolio-grid-image-wrapper" key={idx}>
                <img
                  className="portfolio-grid-image"
                  src={item}
                  alt={`Solo Pints lifestyle ${idx + 1}`}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
